import React from "react";
import styles from "./Spinner.module.scss";

const Spinner: React.FC = () => {
  return (
    <div className={styles.loadingSpinner}>
      {Array.from({length: 6}).map((_, index) => {
        return <div key={index} className={styles.skChaseDot} />;
      })}
    </div>
  );
};

export default Spinner;
